<template>
  <section class="partner-logos" aria-labelledby="partner-logo-title">
    <div class="layout-content">
      <div class="partner-heading">
        <span>{{ isEnLang ? 'PARTNERS' : 'PARTNERS' }}</span>
        <h2 id="partner-logo-title">{{ isEnLang ? 'PARTNERS' : '合作伙伴' }}</h2>
      </div>

      <div class="logo-wall">
        <article class="logo-card logo-card--ican">
          <img src="@/assets/img/ican-logo.png" alt="iCAN" />
        </article>
        <article class="logo-card logo-card--tsinghua">
          <img src="@/assets/img/tsinghua-fintech-institute.png" alt="清华大学金融科技研究院" />
        </article>
        <article class="logo-card logo-card--ieee">
          <img src="@/assets/img/ieee-cis-singapore.png" alt="IEEE Computational Intelligence Society Singapore Chapter" />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['isEnLang'])
  }
}
</script>

<style lang="scss" scoped>
.partner-logos {
  padding: 76px 0 82px;
  background: #fff;

  @include mobile {
    padding: 46px 0 50px;
  }
}

.partner-heading {
  text-align: center;

  > span {
    color: #c72f4e;
    font-family: DIN-BlackItalic, DIN;
    font-size: 10px;
    letter-spacing: 3px;
  }

  h2 {
    margin-top: 8px;
    color: #111820;
    font-size: 30px;
    line-height: 42px;
    font-weight: 700;

    @include mobile {
      font-size: 24px;
      line-height: 34px;
    }
  }
}

.logo-wall {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.45fr) minmax(0, 1fr);
  gap: 18px;
  width: 960px;
  max-width: 100%;
  margin: 36px auto 0;

  @include mobile {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-top: 25px;
  }
}

.logo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 166px;
  padding: 28px 42px;
  border: 1px solid #e4e8ed;
  background:
    radial-gradient(circle at 1px 1px, rgba(29, 47, 69, .045) 1px, transparent 0),
    #fff;
  background-size: 18px 18px;
  transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 38px;
    height: 3px;
    background: #c72f4e;
  }

  &--ieee::before { background: #00a9cf; }
  &--tsinghua::before { background: #a9002c; }

  &:hover {
    transform: translateY(-3px);
    border-color: #cdd3da;
    box-shadow: 0 15px 34px rgba(23, 39, 57, .08);
  }

  img {
    display: block;
    width: auto;
    max-width: 100%;
    max-height: 92px;
    object-fit: contain;
  }

  &--ican img,
  &--ieee img {
    width: 145px;
    height: auto;
    max-height: none;
  }

  // The Tsinghua wordmark is naturally much wider than the other marks;
  // give it a dedicated box so its visual height reads consistently.
  &--tsinghua {
    padding-left: 10px;
    padding-right: 10px;
  }

  &--tsinghua img {
    width: 100%;
    max-width: 300px;
    height: auto;
    max-height: 39px;
    object-fit: contain;
  }

  @include mobile {
    height: 132px;
    padding: 24px 36px;

    img { max-width: 100%; }
    &--ican img,
    &--ieee img { width: 145px; max-width: 100%; height: auto; }
    &--tsinghua img { width: 100%; max-width: 300px; height: auto; max-height: 39px; }
  }
}
</style>
